/*
 * @FilePath     : /fe-estrain-customer/src/plugins/mpxRouterConfig.js
 * @Author       : LiYang
 * @Date         : 2021-11-30 18:59:43
 * @LastEditTime: 2023-05-30 18:49:16
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @Description  : 路由配置
 */

export default (app) => {
  if (__mpx_mode__ === 'web') {
    const { pathname, hostname } = window.location
    // pre-release
    const isPreRelease = pathname.match(/(?:\/pre-release-\w+)/)
    // 10.190.55.97
    const isTest = hostname.match(/(10.190.55.97)/);
    const hasPages =  pathname.match(/(?:\/pages\/)/)
    const hasIndexHtml = pathname.match(/(?:\/index.html)/)
    let base = '' 
    if (isPreRelease) {
      base = isPreRelease[0];
    } else if (isTest) {
      if (hasPages) {
        base = pathname.split('/pages')[0]
      }else if (hasIndexHtml) {
        base = pathname.split('/index.html')[0]
      }   
    }
    app.config.webRouteConfig = {
      mode: 'history',
      base: base.concat('/')
    };
  }
}